import React, { useMemo, useEffect } from 'react';

import makeStyles from '@mui/styles/makeStyles';
import * as yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { noop } from 'common';

import { useApi } from 'common/hooks/api';

import InputRhf from '../FormElements/InputRhf';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    marginTop: theme.spacing(4),
  },
}));

const NewClientForm = React.forwardRef((props, ref) => {
  const classes = useStyles();
  const Api = useApi();
  const { onSubmit = noop, agencyId, onValidChange } = props;

  const schema = useMemo(
    () =>
      yup
        .object({
          firstName: yup.string().required('First name is required'),
          lastName: yup.string().required('Last name is required'),
          email: yup
            .string()
            .email('Email must be valid')
            .test('checkDuplicateEmail', 'Email already exists', async function(value) {
              if (value) {
                const exists = await Api.checkClientEmail(value, agencyId);
                return !exists;
              }
              return true;
            }),
        })
        .required(),
    [Api, agencyId],
  );

  const { handleSubmit, control, formState } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      firstName: '',
      lastName: '',
      email: '',
    },
    mode: 'onChange',
  });

  useEffect(() => {
    if (onValidChange) onValidChange(formState.isValid);
  }, [formState.isValid, onValidChange]);

  const validateForm = handleSubmit(onSubmit);

  React.useImperativeHandle(ref, () => ({
    submit: () => validateForm(),
  }));

  return (
    <div className={classes.root}>
      <InputRhf
        control={control}
        id="title"
        name="title"
        label="Title"
        placeholder=" "
        inputProps={{ maxLength: 4 }}
        data-test-id="new-client-form-title-input"
        autoFocus
      />
      <InputRhf
        control={control}
        id="firstName"
        name="firstName"
        label="First Name"
        placeholder=" "
        required
        data-test-id="new-client-form-firstName-input"
      />
      <InputRhf
        control={control}
        id="lastName"
        name="lastName"
        label="Last Name"
        placeholder=" "
        required
        data-test-id="new-client-form-lastName-input"
      />
      <InputRhf control={control} id="email" name="email" label="Email" placeholder=" " data-test-id="new-client-form-email-input" />
      <InputRhf control={control} id="phone" name="phone" label="Phone" placeholder=" " data-test-id="new-client-form-phone-input" />
      <InputRhf
        control={control}
        id="address"
        name="address"
        label="Address"
        placeholder=" "
        data-test-id="new-client-form-address-input"
      />
    </div>
  );
});

export default NewClientForm;
